import { Component } from '@angular/core';

@Component({
  selector: 'app-public-page',
  templateUrl: './public-page.html',
  styleUrl: './public-page.scss',
  standalone: true,
  imports: [],
})
export class PublicPage {}
